/** Bridge the existing discovery URL bucket to saved-context terminology. */
export const normalizeExamSelection = (value: string) => value === 'unclassified' ? 'unspecified' : value;

export function examScopedPath(path: string, selection: string): string {
  const exam = normalizeExamSelection(selection);
  return exam ? `${path}?${new URLSearchParams({ exam: path === '/tests' && exam === 'unspecified' ? 'unclassified' : exam })}` : path;
}
